<template>
  <div class="Home">
    <div class="enter-links">
      <router-link to="/comics">
        <img class="ffcLogo" src="@/assets/images/comics/ffcLogo.png" alt="" />
      </router-link>
      <router-link to="/comics02">
        <img
          class="comic_entry2"
          src="@/assets/images/comics/comicEntry.png"
          alt=""
        />
      </router-link>
      <router-link to="/help">
        <img
          class="help-enter"
          src="@/assets/images/help/help-enter.png"
          alt="go faq"
        />
      </router-link>
    </div>
    <video
      v-if="checkDevice == 'pc'"
      class="top-bg"
      ref="topBg"
      preload="auto"
      muted
      autoplay
      loop
      src="@/assets/video/bg.mp4"
    ></video>
    <!-- PC版PV背景追加一层蒙版 -->
    <img
      v-if="checkDevice == 'pc'"
      class="top-bg-cover"
      src="@/assets/images/home/bg_cover.png"
    />

    <div class="divBG" v-if="showdiv">
      <div class="shut" @click="hidediv()"></div>
      <div class="divBG_center">
        <iframe
          src="https://www.youtube.com/embed/0KFPtliRn_4"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <div v-if="checkDevice == 'pc'" class="home-ceter">
      <div class="reservation"></div>
      <div class></div>
      <img class="ef" src="../assets/images/home/ef.png" alt />
      <img class="slogan" src="../assets/images/home/slogan.png" alt />
      <!--<img class="scroll" src="../assets/images/home/scroll.png" alt /> -->
      <!--<div class="home_tw">
        <div class="home_tw_center">
          <div class="home_tw_size">
            <a
              class="twitter-timeline"
              href="https://twitter.com/Blue_ArchiveJP"
            ></a>
          </div>
          <img src alt />
        </div>
      </div>-->
      <a href="https://launcher-pkg-ba-jp.yo-star.com/install_pkg/game_launcher/BlueArchive_JP/BlueArchive_JP_Gamelauncher-1.7.2-setup.exe">
        <img
          class="windows-download"
          src="../assets/images/home/windows.png"
          alt
      /></a>

      <a href="https://payment.yostar.co.jp/index">
        <img
          class="charge"
          src="../assets/images/home/charge.png"
          alt
      /></a>

      <a href="https://bit.ly/2YBxMAm">
        <img class="ios-play" src="../assets/images/home/ios-play.png" alt
      /></a>

      <a
        href="https://app.adjust.com/fknal8w?redirect=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.YostarJP.BlueArchive"
      >
        <img
          class="google-play"
          src="../assets/images/home/google-play.png"
          alt
      /></a>

      <!-- <div class="banner banner-one"></div>
      <div class="banner banner-two"></div> -->
    </div>
    <img
      v-if="checkDevice == 'mobile'"
      class="slogan-s"
      src="../assets/images/home/slogan.png"
      alt
    />
    <!-- <div class="time">{{ currentTime }}</div> -->
    <div class="enter-btns" v-if="checkDevice == 'mobile'">
      <img
        @click="videos()"
        class="video"
        src="../assets/images/home/mobile_video.png"
        alt
      />
      <a href="https://payment.yostar.co.jp/index">
        <img class="charge-m" src="../assets/images/home/charge.png" alt
      /></a>
      <a href="https://bit.ly/2YBxMAm">
        <img class="ios-play-m" src="../assets/images/home/ios-play.png" alt
      /></a>
      <a
        href="https://app.adjust.com/fknal8w?redirect=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.YostarJP.BlueArchive"
      >
        <img
          class="google-play-m"
          src="../assets/images/home/google-play.png"
          alt
      /></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",

  components: {},
  data: () => ({
    showdiv: false,
    timer: "", //定义一个定时器的变量
    currentTime: new Date(), // 获取当前时间
  }),
  created() {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://platform.twitter.com/widgets.js";
    document.body.appendChild(s);
    this.getTime();

    if (
      process.env.VUE_APP_ENV === "online" &&
      this.$route.query &&
      this.$route.query.userToken
    ) {
      this.$router.push({
        path: `news/newsJump/preview?userToken=${this.$route.query.userToken}`,
      });
    }
  },
  mounted() {},
  watch: {},
  computed: {
    checkDevice() {
      return this.$utils.checkDevice();
    },
  },
  methods: {
    change(path) {
      this.$router.push(path);
    },
    videos() {
      this.showdiv = true;
    },
    hidediv() {
      this.showdiv = false;
    },
    getTime() {
      this.timer = setInterval(() => {
        this.currentTime =
          new Date().getHours() +
          ":" +
          new Date().getMinutes() +
          ": " +
          new Date().getSeconds();
      }, 1000);
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
};
</script>

<style lang="scss" scoped>
.Home {
  width: 100%;
  font-size: pxTorem(50px);
  // height: pxTorem(1080px);
  // background: url(../assets/images/home/bk.png);
  padding-bottom: pxTorem(1080px);
  position: relative;
  overflow: hidden;

  .enter-links {
    position: absolute;
    right: pxTorem(8px);
    bottom: pxTorem(160px);
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: flex-end;
    z-index: 3;

    .ffcLogo {
      margin-left: pxTorem(8px);
      width: pxTorem(300px);
      cursor: pointer;
    }

    .comic_entry2 {
      margin-left: pxTorem(8px);
      width: pxTorem(260px);
      cursor: pointer;
    }

    .help-enter {
      width: pxTorem(300px);
      cursor: pointer;
    }
  }

  .top-bg {
    position: absolute;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    left: 0%;
    top: 0%;
    transform: translate(0, 0);
    z-index: 0;
    // width: 100%;
    height: 100%;
    transition: opacity 0.3s ease;
  }

  .top-bg-cover {
    position: absolute;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    left: 0%;
    top: 0%;
    transform: translate(0, 0);
    z-index: 1;
    // width: 100%;
    height: 100%;
    transition: opacity 0.3s ease;
  }

  .time {
    width: 1000px;
    height: 100px;
    background: violet;
  }

  .divBG {
    display: none;
    position: fixed;
    z-index: 999;
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    z-index: 20;

    @media screen and (max-width: 600px) {
      display: block;
    }

    filter: alpha(opacity=60);

    .shut {
      position: absolute;
      right: 4%;
      top: 3%;
      width: MpxTorem(50px);
      height: MpxTorem(50px);
      background: url(../assets/images/home/no.png);
      background-size: 100%;
      z-index: 100;
      cursor: pointer;

      @media screen and (max-width: 600px) {
        right: 2.5%;
        top: 33.6%;
      }
    }

    .divBG_center {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      height: 90%;

      iframe {
        width: 100%;
        height: 100%;
      }

      @media screen and (max-width: 600px) {
        height: 30%;
      }

      .Studio_s {
        height: 100%;
        width: 100%;
      }
    }
  }

  .reservation {
    z-index: 2;
    position: absolute;
    height: pxTorem(227px);
    width: pxTorem(650px);
    background: url(../assets/images/home/LogoJP.png);
    background-size: 100% 100%;
    left: 50%;
    top: 51%;
    transform: translate(-50%, -50%);
  }

  .ef {
    position: absolute;
    right: 0;
    width: pxTorem(315px);
    top: pxTorem(136px);
  }

  .slogan {
    z-index: 2;
    position: absolute;
    top: pxTorem(186px);
    right: pxTorem(124px);
    width: pxTorem(156px);
  }

  .scroll {
    position: absolute;
    right: pxTorem(44px);
    top: pxTorem(326px);
    width: pxTorem(40px);
  }

  .home_tw {
    z-index: 2;
    position: absolute;
    left: pxTorem(44px);
    top: pxTorem(409px);
    top: pxTorem(280px);
    width: pxTorem(290px);
    height: pxTorem(526px);
    background: url(../assets/images/home/ipone.png);
    background-size: cover;

    .home_tw_center {
      left: 9.6%;
      position: absolute;
      opacity: 0.7;
      top: 11%;
      box-sizing: border-box;
      width: pxTorem(242px);
      height: pxTorem(330px);

      // overflow-y: auto;

      .home_tw_size {
        overflow-y: auto;
        width: 100%;
        height: 100%;
      }
    }
  }

  .windows-download {
    z-index: 3;
    cursor: pointer;
    left: pxTorem(46px);
    position: absolute;
    width: pxTorem(450px);
    bottom: pxTorem(240px);
  }
  .charge {
    z-index: 3;
    cursor: pointer;
    left: pxTorem(46px);
    position: absolute;
    width: pxTorem(320px);
    bottom: pxTorem(380px);
  }
  .ios-play {
    z-index: 3;
    cursor: pointer;
    left: pxTorem(46px);
    position: absolute;
    width: pxTorem(220px);
    bottom: pxTorem(160px);
  }

  .google-play {
    z-index: 3;
    cursor: pointer;
    position: absolute;
    left: pxTorem(276px);
    width: pxTorem(220px);
    bottom: pxTorem(160px);
  }

  .banner {
    position: absolute;
    bottom: pxTorem(10px);
    width: pxTorem(358px);
    height: pxTorem(126px);
  }

  .banner-one {
    background: wheat;
    right: pxTorem(436px);
  }

  .banner-two {
    background: blue;
    right: pxTorem(62px);
  }
}

@media screen and (max-width: 600px) {
  .Home {
    background: url(../assets/images/home/bks.png);
    background-size: 100% 100%;
    width: 100%;
    overflow: hidden;
    height: MpxTorem(1920px);
    padding-bottom: 0;

    .top-bg {
      display: none;
    }

    .slogan-s {
      width: MpxTorem(306px);
      position: absolute;
      top: MpxTorem(219px);
      left: MpxTorem(44px);
    }

    .slogan-bk {
      width: MpxTorem(306px);
      position: absolute;
      top: MpxTorem(219px);
      left: MpxTorem(44px);
    }

    .ios-play,
    .google-play {
      bottom: pxTorem(120px);
    }

    .enter-btns {
      position: absolute;
      left: pxTorem(80px);
      bottom: pxTorem(120px);
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      z-index: 3;

      .video {
        width: MpxTorem(386px);
      }
      .charge-m {
        margin-top: MpxTorem(30px);
        width: MpxTorem(375px);
      }
      .ios-play-m {
        margin-top: MpxTorem(30px);
        width: MpxTorem(375px);
      }

      .google-play-m {
        margin-top: MpxTorem(30px);
        width: MpxTorem(375px);
      }
    }

    .enter-links {
      position: absolute;
      right: pxTorem(50px);
      bottom: pxTorem(120px);
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
      align-items: center;
      z-index: 3;

      .help-enter {
        width: MpxTorem(400px);
        cursor: pointer;
      }

      .comic_entry2 {
        width: MpxTorem(400px);
        margin-left: 0;
        cursor: pointer;
      }

      .ffcLogo {
        margin-top: MpxTorem(10px);
        width: MpxTorem(450px);
        margin-left: MpxTorem(30px);
        cursor: pointer;
      }
    }
  }
}
</style>
